import { render } from "./EmptyStarIcon.vue?vue&type=template&id=7ecaab14"
import script from "./EmptyStarIcon.vue?vue&type=script&lang=js"
export * from "./EmptyStarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__